import { memo } from "react";

import { QuestionKidsPolicy } from "@/components/features/items/edit/_shared/ui/components/main/questions/kids-policy";

import { useDummyRoomKidsPolicy } from "./hooks/use-kids-policy/use-kids-policy";

export const QuestionDummyRoomKidsPolicy = memo(() => {
	const {
		kidsPolicy,
		append,
		canRemoveKidsPolicyItem,
		removeKidsPolicyByIndex,
		getMinAge,
		kidsMaxAgeOptions,
		updateMaxAge,
		discountTypeOptions,
		updateDiscountType,
		ratioOptions,
		updateRatio,
		updateStaticPrice,
	} = useDummyRoomKidsPolicy();

	const label = "部屋独自のキッズポリシー";
	const guide =
		"ホテルポリシーで設定したポリシーと異なるキッズポリシーを設定できます。未設定の場合、ホテルポリシーで設定したキッズポリシーが適用されます。";

	return (
		<QuestionKidsPolicy
			label={label}
			guide={guide}
			appendKidsPolicyItem={append}
			kidsPolicy={kidsPolicy?.value ?? undefined}
			isEdited={kidsPolicy?.isEdited}
			hasError={kidsPolicy?.hasError}
			questionKidsPolicyItemProps={{
				canRemoveKidsPolicyItem,
				kidsPolicyKidsMaxAgeMinAge: getMinAge,
				kidsPolicyKidsMaxAgeOptions: kidsMaxAgeOptions,
				changeKidsPolicyMaxAge: updateMaxAge,
				discountTypeOptions,
				changeKidsPolicyDiscountType: updateDiscountType,
				kidsPolicyRatioOptions: ratioOptions,
				changeKidsPolicyRatio: updateRatio,
				changeKidsPolicyStaticPrice: updateStaticPrice,
				removeKidsPolicyItemByIndex: removeKidsPolicyByIndex,
			}}
		/>
	);
});

QuestionDummyRoomKidsPolicy.displayName = "QuestionDummyRoomKidsPolicy";
